import FactorReceiveActivity from "./FactorReceiveActivity";
import FactorReceiveActivityPopup from "./FactorReceiveActivityPopup";

export default FactorReceiveActivity;

export { FactorReceiveActivityPopup };
